// Convert areasInput → clean array
export const toAreasArray = (areasInput) => {
  if (Array.isArray(areasInput)) return areasInput;
  if (areasInput && Array.isArray(areasInput.items)) return areasInput.items;
  return [];
};

// Convert areas to GeoJSON FeatureCollection
export function areasToGeoJSON(areasInput, selectedIds = []) {
  const areas = toAreasArray(areasInput);
  const selectedSet = new Set(selectedIds || []);

  const features = areas
    .map((area) => {
      const geom = area.geometry;
      if (!geom || !geom.type || !geom.coordinates) return null;

      const props = area.properties || {};
      const areaId = area.area_id ?? area.id;

      return {
        type: "Feature",
        id: areaId, // needed for feature-state if we want later
        geometry: {
          type: geom.type,
          coordinates: geom.coordinates,
        },
        properties: {
          ...props,
          area_id: areaId,
          name: area.name || area.name_el || `Area ${areaId}`,
          selected: selectedSet.has(areaId),
        },
      };
    })
    .filter(Boolean);

  return {
    type: "FeatureCollection",
    features,
  };
}

// Update only the source data (same pattern as routes/events)
export function addOrUpdateAreas(map, areasInput = [], selectedIds = []) {
  if (!map) return;

  const geojson = areasToGeoJSON(areasInput, selectedIds);
  const source = map.getSource("scenario-areas-source");

  console.log("scenario-areas-source payload", {
    featureCount: geojson.features.length,
    geometryTypes: [...new Set(geojson.features.map((feature) => feature.geometry?.type))],
    firstFeature: geojson.features[0] || null,
  });

  if (source && source.setData) {
    source.setData(geojson);
  }
}
